import {Injectable} from '@angular/core';
import {QuestionnaireApi} from '../api/questionnaire.api';
import {EdlForm} from '../components/form-builder/models/edl-form.model';
import { CplItem } from '../model/cpl-item.model';
import { CplQfmDuplicateData } from '../model/cpl-qfm-duplicate-data.model';
@Injectable()
export class QuestionnaireService {


    constructor(private questionnaireApi: QuestionnaireApi) { }

    getQuestionnairesForPortal = ({
        portalId,
        availability,
        offset,
        limit,
        orderBy,
        ascending,
        searchBy,
        status,
    } : {
        portalId: number,
        availability: number,
        offset?: number,
        limit?: number,
        orderBy?: string,
        ascending?: boolean,
        searchBy?: string,
        status?: number
    }) =>
        this.questionnaireApi.getQuestionnairesForPortal({portalId, availability, offset, limit, orderBy, ascending, searchBy, status});

    getQuestionnaireById = (id: string) => this.questionnaireApi.getQuestionnaireById(id);

    saveQuestionnaire = (questionnaire: EdlForm) => this.questionnaireApi.saveQuestionnaire(questionnaire);

    deleteQuestionnaire = (questionnaire: EdlForm) => this.questionnaireApi.deleteQuestionnaire(questionnaire);

    restoreQuestionnaire = (questionnaire: EdlForm) => this.questionnaireApi.restoreQuestionnaire(questionnaire);

    removeQuestionnaire = (questionnaire: EdlForm) => this.questionnaireApi.removeQuestionnaire(questionnaire);
    
    activateQuestionnaire = (questionnaire: EdlForm) => this.questionnaireApi.activateQuestionnaire(questionnaire);

    archiveQuestionnaire = (questionnaire: EdlForm) => this.questionnaireApi.archiveQuestionnaire(questionnaire);

    convertQuestionnaireToTemplate = (questionnaire: EdlForm) => this.questionnaireApi.convertQuestionnaireToTemplate(questionnaire);

    duplicateQuestionnaire = (data: CplQfmDuplicateData) => this.questionnaireApi.duplicateQuestionnaire(data);

    getUserForm = (userFormId: string) => this.questionnaireApi.getUserForm(userFormId);

    createUserFormIfNotExist = (userRequestId: string, qfmId: string) => this.questionnaireApi.createUserFormIfNotExist(userRequestId, qfmId);

    getUserFormHistory = (UserFormId: string, historyId: number) => this.questionnaireApi.getUserFormHistory(UserFormId, historyId);

    completeQuestionnaire = (payload: Object) => this.questionnaireApi.completeQuestionnaire(payload);

    getQuestionnaireUsage = (complianceItem: CplItem) => this.questionnaireApi.getQfmUsageReport(complianceItem);

    getAllQuestionnaireUsage = (ItemID: string): any => this.questionnaireApi.getAllQuestionnaireUsage(ItemID);

    getCurrentCycleQuestionnaireUsage = (ItemID: string): any => this.questionnaireApi.getCurrentCycleQuestionnaireUsage(ItemID);

    getCycleQuestionnaireUsage = (ItemID: string, itemCycleId: string): any => 
        this.questionnaireApi.getCycleQuestionnaireUsage(ItemID, itemCycleId);

    getRequestQuestionnaireUsage = (requestID: string, qfmID, followup: number): any => 
        this.questionnaireApi.getRequestQuestionnaireUsage(requestID, qfmID, followup);

    getQuestionnairesForRequest = (requestId: string) : any => this.questionnaireApi.getQuestionnairesForRequest(requestId);

    recalculate = (payload: Object) => this.questionnaireApi.recalculate(payload);
}